import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { MockAuthProvider } from '@/app/providers/MockAuthProvider'
import { AppRouter } from '@/routes'
import '@/index.css'

const rootElement = document.getElementById('root')

if (!rootElement) {
  throw new Error('Root element #root not found')
}

createRoot(rootElement).render(
  <StrictMode>
    <MockAuthProvider>
      <AppRouter />
    </MockAuthProvider>
  </StrictMode>,
)
